import { array, struct } from 'io-ts/Decoder';

import { Id as UserId } from '../../../user/Id';

export const Request = struct({
	userIds: array(UserId),
});
